(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxHomeOffice(
    $timeout, $http, $filter, toastr, $location, GroupModel, $rootScope, GroupFilterModel
  ) {
    return {
      restrict: 'EA',
      scope: {
        tenant: '=tenant',
        me: '=me',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/settings/homeOffice/homeOffice.template.html',
      link: function(scope) {

        scope.selectedContextMenuItem = null;
        scope.context = null;
        scope.checkAllCheckboxes = false;
        scope.loadingPage = true;
        scope.homeOfficeGroups = [];
        scope.search = { string: ""};
        scope.filtersList = new GroupFilterModel('HOME_OFFICE_QUEUE_GROUPS_STATIC').filters;
        if (scope.filtersList.length) {
          scope.filtersList[0].setBreaker = false;
        }
        scope.mockedPagingObject = {
          pagingCriteria: {}
        };
        scope.filterModel = {
          info: {name: '' },
        };
        scope.dialog = {
          state: 'CLOSED',
          mode: 'NONE'
        };
        scope.selectedGroups = [];
        scope.modifyGroups = [];
        scope.updateProgression = [];
        scope.UI_LOCK = false;

        (() => {
          setListeners();
          scrollListener();
        })()

        scope.$watch(function () {
          return scope.tenant;
        }, function () {
          getHomeOfficeGroups();
        })

        function getHomeOfficeGroups () {
          scope.loadingPage = true;
          scope.homeOfficeGroups = [];
          $http.get(scope.tenant.info._links['px:homeOfficeGroups'].href).then(function(response) {
            if (response.data._embedded) {

              var homeOfficeGroups = groupModelList(response.data._embedded['px:groupResources']);
              console.log('** homeOfficeGroups : ', homeOfficeGroups);
              scope.homeOfficeGroups = homeOfficeGroups.slice().sort((a, b) => a.info.name.localeCompare(b.info.name));
            }
            scope.loadingPage = false;
          }).catch(function(error) {
            scope.loadingPage = false;
          });
        }

        function groupModelList (groupResources) {
          var groupList = []
          angular.forEach(groupResources, function(groupResource) {
            groupList.push(new GroupModel(groupResource));
          })
          return groupList;
        }

        scope.reloadList = function () {
          scope.homeOfficeGroups = [];

          scope.loadingPage = true;
          $timeout(() => {
            getHomeOfficeGroups();
          },500)
        }

        scope.openDialog = function (mode) {
          scope.context = { name: "AddHomeOfficeGroups", task: 'EDIT_HOME_OFFICE_GROUPS', endpoint: scope.tenant.info._links['px:homeOfficeGroups'].href};
          scope.dialog.state = 'OPEN';
          scope.dialog.mode = mode;
        }


        scope.selectAllItems = function () {
          if (scope.checkAllCheckboxes) {
            angular.forEach(scope.groups, function(value) {
              value.options.isSelected = scope.checkAllCheckboxes;
            });
          }

          if (!scope.checkAllCheckboxes) {
            angular.forEach(scope.homeOfficeGroups, function(value) {
              value.options.isSelected = scope.checkAllCheckboxes;
            });
          }

        }

        scope.closeDialog = function (exitState) {

          if (exitState === 'UPDATING') {
            scope.UI_LOCK = true;
            angular.forEach(scope.groups, (group) => {
              group.options.isSelected = false;
            })
          }
          scope.context = null;
          scope.dialog.state = 'CLOSED';
          scope.dialog.mode = 'NONE';
        }

        scope.$watch(function() {
          if (scope.homeOfficeGroups) {
            return scope.homeOfficeGroups;
          }
        }, function() {
          if (scope.homeOfficeGroups) {
            scope.modifyGroups = scope.selectedGroups = scope.homeOfficeGroups.findAllElements({
              options: {
                isSelected: true
              }
            });
            if (!scope.homeOfficeGroups.length) {
              scope.checkAllCheckboxes = false;
            } else {
              scope.checkAllCheckboxes = (scope.selectedGroups.length === scope.homeOfficeGroups.length);
            }
          }
        }, true);

        scope.setFilters = function () {
          for (const key in scope.mockedPagingObject.pagingCriteria) {
            const value = scope.mockedPagingObject.pagingCriteria[key];
            if (value === true || value === false) {
              scope.filterModel[key] = value;
            } else if (value === null && scope.filterModel.hasOwnProperty(key)) {
              delete scope.filterModel[key];
            }
          }

        }

        scope.domainFiltering = function  (group) {
          var filteredGroup = null;
          if (!scope.mockedPagingObject.pagingCriteria.directories) {
            filteredGroup = group
          } else {

            scope.mockedPagingObject.pagingCriteria.directories.forEach((directory) => {
              if (group.domainOrigin._links.self.href === directory) {
                filteredGroup = group
              }
            })
          }
          return filteredGroup;
        }

        scope.openContextMenu = function (event, context, menuOption){
          $timeout(function  () {
            scope.selectedContextMenuItem  =  menuOption;
            scope.contextPosition = { left: event.clientX, top: event.clientY }
            scope.context = context;
            scope.resource = scope.tenant;
          }, 50)
        }

        scope.closeAllMenues = function () {
          scope.selectedContextMenuItem  =  null;
          scope.contextPosition = null;
          scope.context = null;
        }

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // TOOLTIP STUFF
        ////////////////////////////////////////////
        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          if (showTip) {
            switch(tooltipScope) {
              case 'statement':
                siteTooltip(position, context);
              break;
              case 'statement-fallback':
                toolTipFallback(position, context)
              break;
            }
          }
          else {
            scope.clearTooltip();
          }
        }

        function siteTooltip (position, title) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: title,
            type: 'statement',
          }
          scope.tooltipObject = {
            position: {left: position.startX, top: position.startY + 20}
          }
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        }

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // LIST MENU
        ////////////////////////////////////////////
        scope.openListMenu = function (event, group) {
          var position = document.getElementById(event.target.id).getBoundingClientRect();
          setTimeout(function () {
            scope.closeListMenu();
            group.customProperties = {id: group.id};
            scope.listMenuContext = group;
            scope.listMeta = {
              position: {left: position.x, top: position.y},
              parentId: event.target.id,
              type: 'homeOfficeGroup',
              scrollContainerId: 'HOME_OFFICE_GROUP_SCROLL_CONTAINER'
            }
            scope.$apply();
          }, 50)
        }

        scope.closeListMenu = function (group, action) {
          scope.listMenuContext = null;
          scope.listMeta = null;

          switch (action) {
            case 'REMOVE':
              scope.modifyGroups = [group]
              scope.openDialog('REMOVE_GROUPS');
            break;
            case 'MODIFY':
              scope.modifyGroups = [group]
              scope.openDialog('MODIFY_GROUPS');
            break;
          }
        }

        function scrollListener () {
          var scrollLeft = 0;
          var scrollTop = 0;

          angular.element('#HOME_OFFICE_GROUP_SCROLL_CONTAINER').on('scroll', function (event) {
            if (event.currentTarget.scrollLeft !== scrollLeft) {
              scope.scrollingLEFT = true;
              scrollLeft = event.currentTarget.scrollLeft;
              scope.$apply();
            } else {
              scope.scrollingLEFT = false
            }
            if (scope.scrollingLEFT) {
              $timeout(() => {
                scope.scrollingLEFT = false;
              }, 1500)
            }
          });
        }

        function setListeners () {
          $rootScope.$on('UPDATE_HOME_OFFICE_GROUPS', ()=>{
            getHomeOfficeGroups()
          })
        }

      }
    };
  }

pxHomeOffice.$inject = [
  '$timeout', '$http',  '$filter', 'toastr', '$location', 'GroupModel', '$rootScope', 'GroupFilterModel'
];

  angular
    .module('printix-admin')
    .directive('pxHomeOffice', pxHomeOffice);

})();
